import request from '../request'

// 获取cvslist
export const getCvsList = (params) => {
  return request({
    url: `/v3/cvs`,
    method: 'get',
    params
  })
}

// 获取cv template
export const getCvsTemplate = (token) => {
  return request({
    url: `/v3/cv_accounts/${token}/get_suggested_template_names`,
    method: 'get'
  })
}

// 更新简历为可编辑
export const editableCv = (data) => {
  return request({
    url: `/v3/editable_cvs`,
    method: 'post',
    data
  })
}

// 内推详情列表
export const pushInList = (params) => {
  return request({
    url:`/v3/internal_recommends`,
    method: 'get',
    params
  })
}

// 获取讨论信息
export const talkto = (params) => {
  return request({
    url:`v3/bbs/news/recommend_news`,
    method: 'get',
    params
  })
}

// 导入简历
export const uploadResume = (data) => {
  return request({
    url:`v3/cvs/imports`,
    method: 'POST',
    data,
    header: {'Content-Type':'multipart/form-data'}
  })
}
// 获取默认模块标题
export const getCvSectionTitle = () => {
  return request({
    url: `/v3/section_titles`,
    method: 'get'
  });
}
// 获取简历批注
export const getAllCvComment = (cv_token, params) => {
  return request({
    url: `/v3/cvs/${cv_token}/all_cv_comments`,
    method: 'get',
    params: params || {}
  });
}

// 获取简历画像相关信息（亮点/风险点/技能关键词）
export const getCvPortrait = cvToken => {
  return request({
    url: `/v3/cvs/${cvToken}/portrait`,
    method: 'get',
    params: {}
  });
}

// 获取简历模块模板信息
export const getCvTemplateInfo = () => {
  return request({
    url: `/v3/cvs/submodule_template`,
    method: 'get'
  });
}

// 批量修改HR 邀约为已读状态
export const updateHrPermissions = () => {
  return request({
    url: `/v3/resume_hr_permissions`,
    method: 'POST'
  });
}

// 获取模拟面试结果
export const getMockInterview = (cv_token) => {
  return request({
    url: `/v3/cvs/${cv_token}/chat`,
    method: 'GET'
  });
}

// const AGENT_HOST = process.env.NODE_ENV == 'development' ? '/agent' : process.env.AGENT_HOST;

// // 简历检查-模拟面试
// export const sendMockInterview = (cv_token, data) => {
//   return request({
//     url: `${AGENT_HOST}/chat/ai_cvs/new_chat`,
//     method: 'POST',
//     data: {
//       ...(data || {}),
//       cv_token,
//     }
//   });
// }

export const sendMockInterview = (cv_token, data) => {
  return request({
    url: `/v3/cvs/${cv_token}/new_chat`,
    method: 'POST',
    data
  });
}
